import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantity", "submit", "preset", "step"]
  static values = { correction: Boolean, kind: String }

  connect() { this.update() }

  choose(event) {
    this.quantityTarget.value = event.currentTarget.dataset.quantity
    this.update()
  }

  adjust(event) {
    const entered = Number(this.quantityTarget.value)
    const current = Number.isInteger(entered) && entered >= 0 ? entered : 0
    this.quantityTarget.value = String(Math.min(1000000, Math.max(0, current + Number(event.currentTarget.dataset.delta))))
    this.update()
  }

  update() {
    const value = this.quantityTarget.value
    const valid = /^[0-9]+$/.test(value) && Number(value) >= 1 && Number(value) <= 1000000
    const receipt = this.kindValue === "received"
    const suffix = this.correctionValue ? "に訂正する" : (receipt ? "の受取を記録する" : "を報告する")
    this.submitTarget.value = valid ? `${Number(value).toLocaleString("ja-JP")}枚${suffix}` :
      (this.correctionValue ? "訂正を保存する" : (receipt ? "受取を記録する" : "報告を送信"))
    if (receipt) this.submitTarget.disabled = !valid
    for (const preset of this.presetTargets || []) {
      preset.setAttribute("aria-pressed", String(valid && Number(value) === Number(preset.dataset.quantity)))
    }
    for (const step of this.stepTargets || []) {
      step.disabled = Number(step.dataset.delta) < 0 ? !valid : (valid && Number(value) >= 1000000)
    }
  }
}
